module.exports = __webpack_public_path__ + "static/media/stockhausen_polymorph_9.5cc323fe.jpg";